import React from "react";
import classNames from "classnames";

import { Props, DateType } from "./types";
import { Years } from "./years";
import styles from "./styles.scss";
import { SelectList } from "@common/selectList";

function YearSelector({ initialCursor, ...props }: Props) {
  const [cursor, setCursor] = React.useState(
    new Date(
      initialCursor ? initialCursor : new Date(props.year, 1, 1).toISOString(),
    ),
  );
  const minDate = props.minDate
    ? new Date(props.minDate.year, props.minDate.month, props.minDate.day)
    : new Date(0);
  const maxDate = props.maxDate
    ? new Date(props.maxDate.year, props.maxDate.month, props.maxDate.day)
    : new Date(99999, 1);

  const handleCursorChange = (newDate: Partial<DateType>) => {
    const { year, month, day } = {
      year: cursor.getFullYear(),
      month: cursor.getMonth(),
      day: cursor.getDate(),
      ...newDate,
    };
    const nextDate = new Date(year, month, day);

    setCursor(
      nextDate < minDate ? minDate : nextDate > maxDate ? maxDate : nextDate,
    );
  };

  return (
    <SelectList listClassName={styles.calendarRoot}>
      {({ select }) => ({
        input: (
          <div className={styles.input}>
            <p>{props.year}</p>
          </div>
        ),
        list: (
          <div className={styles.calendar}>
            <div className={styles.years}>
              <Years
                year={props.year}
                cursor={cursor}
                maxDate={props.maxDate}
                minDate={props.minDate}
                editCursor={handleCursorChange}
                select={(y) => {
                  props.select(y);

                  select(null);
                }}
                clear={props.clear}
                today={props.today}
              />
            </div>
          </div>
        ),
      })}
    </SelectList>
  );
}

export { YearSelector };
